/* LAMY ngăn giỏ (04/11): thêm vào giỏ thì ảnh bay vào biểu tượng giỏ + mở ngăn giỏ (điện thoại: trượt từ đáy; máy tính: ngăn phải).
   Bấm biểu tượng giỏ / tab Giỏ hàng / "Xem giỏ" cũng mở ngăn này thay cho ngăn giỏ cũ của theme. Sửa số lượng, xoá ngay trong ngăn. */
(function () {
  'use strict';
  if (window.LamySheet) return;
  var RM = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var EASE = 'cubic-bezier(.22,1,.36,1)';
  var money = function (c) { return Math.round(c / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') + 'đ'; };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
  var img = function (u, w) { if (!u) return ''; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; };
  var onCartPage = location.pathname.indexOf('/cart') === 0;

  var css = [
    '.lcs{position:fixed;inset:0;z-index:100030;visibility:hidden;pointer-events:none}',
    '.lcs.on{visibility:visible;pointer-events:auto}',
    '.lcs-ov{position:absolute;inset:0;background:rgba(53,32,42,.42);opacity:0;transition:opacity .25s ease}',
    '.lcs.on .lcs-ov{opacity:1}',
    '.lcs-sh{position:absolute;left:0;right:0;bottom:0;max-height:86vh;display:flex;flex-direction:column;background:#FFF7F9;color:#35202A;border-radius:20px 20px 0 0;box-shadow:0 -10px 30px rgba(53,32,42,.16);transform:translateY(100%);transition:transform .34s ' + EASE + ';font-family:"Be Vietnam Pro",system-ui,sans-serif;outline:0}',
    '.lcs.on .lcs-sh{transform:none}',
    '@media(min-width:768px){.lcs-sh{left:auto;top:0;width:420px;max-height:none;border-radius:20px 0 0 20px;transform:translateX(100%)}}',
    '.lcs-grab{width:38px;height:5px;border-radius:3px;background:rgba(53,32,42,.22);margin:8px auto 0;flex:none}',
    '@media(min-width:768px){.lcs-grab{display:none}}',
    '.lcs-hd{display:flex;align-items:center;justify-content:space-between;padding:10px 12px 8px 20px;flex:none;touch-action:none}',
    '.lcs-hd h2{margin:0;font:600 18px/26px "Montserrat","Be Vietnam Pro",sans-serif!important;letter-spacing:-.2px!important;color:#35202A}',
    '.lcs-hd h2 small{font:500 13px/1 "Be Vietnam Pro",sans-serif;color:#7A6470;margin-left:6px}',
    '.lcs-x{width:44px;height:44px;border:0;border-radius:22px;background:transparent;color:#35202A;display:grid;place-items:center;cursor:pointer;touch-action:manipulation}',
    '.lcs-x:active{background:rgba(53,32,42,.08)}',
    '.lcs-ok{margin:0 20px 6px;padding:10px 12px;border-radius:12px;background:#fff;display:flex;gap:10px;align-items:center;font:500 13px/18px "Be Vietnam Pro",sans-serif;flex:none;animation:lcsIn .4s ' + EASE + '}',
    '.lcs-ok i{flex:none;width:22px;height:22px;border-radius:11px;background:#35202A;color:#FFF7F9;display:grid;place-items:center;font-style:normal;font-size:12px}',
    '@keyframes lcsIn{from{opacity:0;transform:translateY(-6px)}to{opacity:1;transform:none}}',
    '.lcs-list{overflow:auto;-webkit-overflow-scrolling:touch;overscroll-behavior:contain;padding:4px 20px;flex:1 1 auto;min-height:80px}',
    '.lcs-it{display:grid;grid-template-columns:72px 1fr 36px;gap:12px;padding:12px 0;border-bottom:.5px solid rgba(53,32,42,.12);transition:opacity .2s ease,background-color .6s ease}',
    '.lcs-it.is-new{background:linear-gradient(90deg,rgba(194,37,92,.07),rgba(194,37,92,0));border-radius:12px}',
    '.lcs-it.is-busy{opacity:.55;pointer-events:none}',
    '.lcs-it.is-out{animation:lcsOut .26s ease forwards}',
    '@keyframes lcsOut{to{opacity:0;transform:translateX(24px)}}',
    '.lcs-im{display:block;width:72px;height:72px;border-radius:12px;overflow:hidden;background:#fff}',
    '.lcs-im img{width:100%;height:100%;object-fit:contain;display:block}',
    '.lcs-bd{min-width:0;display:flex;flex-direction:column;gap:4px}',
    '.lcs-t{font:500 14px/20px "Be Vietnam Pro",sans-serif;color:#35202A!important;text-decoration:none!important;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}',
    '.lcs-v{margin:0;font:400 12px/17px "Be Vietnam Pro",sans-serif;color:#7A6470}',
    '.lcs-ln{display:flex;align-items:center;justify-content:space-between;gap:8px;margin-top:4px}',
    '.lcs-q{display:flex;align-items:center;height:36px;border-radius:18px;background:#fff;border:.5px solid rgba(53,32,42,.16)}',
    '.lcs-q button{width:36px;height:36px;border:0;background:transparent;color:#35202A;font:500 18px/1 "Be Vietnam Pro",sans-serif;cursor:pointer;touch-action:manipulation;border-radius:18px}',
    '.lcs-q button:active{background:rgba(53,32,42,.08)}',
    '.lcs-q span{min-width:22px;text-align:center;font:600 14px/1 "Be Vietnam Pro",sans-serif}',
    '.lcs-p{font:600 14px/20px "Be Vietnam Pro",sans-serif;white-space:nowrap;text-align:right}',
    '.lcs-p s{display:block;font-weight:400;font-size:12px;color:#9a8790}',
    '.lcs-rm{width:36px;height:36px;border:0;border-radius:18px;background:transparent;color:#7A6470;display:grid;place-items:center;cursor:pointer;touch-action:manipulation}',
    '.lcs-rm:active{background:rgba(53,32,42,.08)}',
    '.lcs-err{grid-column:2/4;margin:0;font-size:12px;line-height:17px;color:#C2255C}',
    '.lcs-empty{padding:28px 0 12px;text-align:center}',
    '.lcs-empty p{margin:0 0 14px;font:500 15px/22px "Be Vietnam Pro",sans-serif}',
    '.lcs-ft{flex:none;padding:14px 20px calc(14px + env(safe-area-inset-bottom,0px));background:#FFF7F9;border-top:.5px solid rgba(53,32,42,.12)}',
    '.lcs-tot{display:flex;justify-content:space-between;align-items:baseline;font:500 14px/20px "Be Vietnam Pro",sans-serif}',
    '.lcs-tot b{font:600 20px/26px "Montserrat","Be Vietnam Pro",sans-serif}',
    '.lcs-note{margin:2px 0 12px;font:400 12px/17px "Be Vietnam Pro",sans-serif;color:#7A6470}',
    '.lcs-pay,.lcs-go{display:flex;align-items:center;justify-content:center;width:100%;height:52px;border-radius:14px;background:#35202A;color:#FFF7F9!important;text-decoration:none!important;font:600 15px/1 "Be Vietnam Pro",sans-serif;border:0;cursor:pointer;touch-action:manipulation;transition:transform .12s ease-out,opacity .12s}',
    '.lcs-pay:active,.lcs-go:active{transform:scale(.98);opacity:.92}',
    '.lcs-row2{display:flex;gap:10px;margin-top:8px}',
    '.lcs-row2 a,.lcs-row2 button{flex:1;display:flex;align-items:center;justify-content:center;height:46px;border-radius:14px;border:1px solid rgba(53,32,42,.22);background:transparent;color:#35202A!important;text-decoration:none!important;font:500 14px/1 "Be Vietnam Pro",sans-serif;cursor:pointer;touch-action:manipulation}',
    '.lcs-row2 a:active,.lcs-row2 button:active{background:rgba(53,32,42,.06)}',
    'html.lcs-lock,html.lcs-lock body{overflow:hidden!important}',
    '.lcs-fly{position:fixed;z-index:100040;pointer-events:none;border-radius:50%;object-fit:cover;background:#fff;box-shadow:0 8px 22px rgba(53,32,42,.28)}',
    '@media(prefers-reduced-motion:reduce){.lcs-sh,.lcs-ov{transition:none}.lcs-ok,.lcs-it.is-out{animation:none}}'
  ].join('\n');
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

  var X_SVG = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>';
  var BIN_SVG = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M4 7h16M9 7V5h6v2M7 7l1 12h8l1-12"/></svg>';

  var root, sheet, list, sumEl, cntEl, okEl, lastFocus = null, cart = null, newIds = [];
  function build() {
    if (root) return;
    root = document.createElement('div');
    root.className = 'lcs';
    root.innerHTML = '<div class="lcs-ov" data-x></div>' +
      '<aside class="lcs-sh" role="dialog" aria-modal="true" aria-labelledby="lcs-h" tabindex="-1">' +
      '<div class="lcs-grab" aria-hidden="true"></div>' +
      '<div class="lcs-hd"><h2 id="lcs-h">Giỏ hàng<small class="lcs-n"></small></h2><button type="button" class="lcs-x" data-x aria-label="Đóng giỏ hàng">' + X_SVG + '</button></div>' +
      '<div class="lcs-okwrap"></div>' +
      '<div class="lcs-list" aria-live="polite"></div>' +
      '<div class="lcs-ft"><div class="lcs-tot"><span>Tạm tính</span><b class="lcs-sum">0đ</b></div>' +
      '<p class="lcs-note">Thanh toán khi nhận hàng · Kiểm tra hàng khi nhận</p>' +
      '<a class="lcs-pay" href="/checkout">Thanh toán</a>' +
      '<div class="lcs-row2"><a href="/cart">Xem giỏ hàng</a><button type="button" data-x>Mua tiếp</button></div></div>' +
      '</aside>';
    document.body.appendChild(root);
    sheet = root.querySelector('.lcs-sh'); list = root.querySelector('.lcs-list');
    sumEl = root.querySelector('.lcs-sum'); cntEl = root.querySelector('.lcs-n'); okEl = root.querySelector('.lcs-okwrap');
    root.addEventListener('click', function (e) {
      var t = e.target;
      if (t.closest('[data-x]')) { e.preventDefault(); close(); return; }
      var q = t.closest('.lcs-q button');
      if (q) { var it = q.closest('.lcs-it'); change(it, +it.getAttribute('data-q') + (+q.getAttribute('data-d'))); return; }
      var rm = t.closest('.lcs-rm');
      if (rm) { change(rm.closest('.lcs-it'), 0); return; }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && root.classList.contains('on')) close(); });
    /* vuốt xuống ở đầu ngăn để đóng (điện thoại) */
    var y0 = null, dy = 0, hd = root.querySelector('.lcs-hd'), grab = root.querySelector('.lcs-grab');
    [hd, grab].forEach(function (h) {
      h.addEventListener('touchstart', function (e) { y0 = e.touches[0].clientY; dy = 0; sheet.style.transition = 'none'; }, { passive: true });
      h.addEventListener('touchmove', function (e) { if (y0 == null) return; dy = Math.max(0, e.touches[0].clientY - y0); sheet.style.transform = 'translateY(' + dy + 'px)'; }, { passive: true });
      h.addEventListener('touchend', function () { if (y0 == null) return; sheet.style.transition = ''; sheet.style.transform = ''; y0 = null; if (dy > 80) close(); });
    });
  }

  function propsText(p) {
    if (!p) return '';
    return Object.keys(p).filter(function (k) { return k.charAt(0) !== '_' && p[k]; }).map(function (k) { return esc(k) + ': ' + esc(p[k]); }).join(' · ');
  }
  function render(c) {
    cart = c;
    cntEl.textContent = c.item_count ? ' (' + c.item_count + ')' : '';
    sumEl.textContent = money(c.total_price);
    root.querySelector('.lcs-ft').style.display = c.item_count ? '' : 'none';
    if (!c.items.length) {
      list.innerHTML = '<div class="lcs-empty"><p>Giỏ hàng đang trống</p><a class="lcs-go" href="/collections/all">Xem trang sức</a></div>';
      return;
    }
    list.innerHTML = c.items.map(function (it) {
      var v = it.variant_title && it.variant_title !== 'Default Title' ? esc(it.variant_title) : '';
      var pr = propsText(it.properties);
      var sub = [v, pr].filter(Boolean).join(' · ');
      var isNew = newIds.indexOf(it.variant_id) > -1 || newIds.indexOf(it.product_id) > -1;
      var old = it.original_line_price > it.final_line_price ? '<s>' + money(it.original_line_price) + '</s>' : '';
      return '<div class="lcs-it' + (isNew ? ' is-new' : '') + '" data-key="' + esc(it.key) + '" data-q="' + it.quantity + '">' +
        '<a class="lcs-im" href="' + esc(it.url) + '"><img src="' + esc(img(it.image, 160)) + '" alt="" width="72" height="72" loading="lazy"></a>' +
        '<div class="lcs-bd"><a class="lcs-t" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' +
        (sub ? '<p class="lcs-v">' + sub + '</p>' : '') +
        '<div class="lcs-ln"><div class="lcs-q" role="group" aria-label="Số lượng"><button type="button" data-d="-1" aria-label="Bớt 1">−</button><span>' + it.quantity + '</span><button type="button" data-d="1" aria-label="Thêm 1">+</button></div>' +
        '<b class="lcs-p">' + old + money(it.final_line_price) + '</b></div></div>' +
        '<button type="button" class="lcs-rm" aria-label="Xoá ' + esc(it.product_title) + '">' + BIN_SVG + '</button></div>';
    }).join('');
  }
  function syncCount(c) {
    if (window.LamyCart && LamyCart.setCount) LamyCart.setCount(c.item_count);
    else document.querySelectorAll('.bigcounter').forEach(function (x) { x.textContent = c.item_count; });
    if (window.Shopify && Shopify.cartUpdateInfo) { try { Shopify.cartUpdateInfo(c, '.single-cart-item-loop'); } catch (e) {} }
    var b = document.querySelector('.lm-tab[data-p="cart"] [data-n]');
    if (b) { b.textContent = c.item_count; b.classList.toggle('z', !c.item_count); }
  }
  function load() { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); }

  var busy = false;
  function change(it, q) {
    if (!it || busy) return;
    busy = true;
    var key = it.getAttribute('data-key');
    q = Math.max(0, q);
    it.classList.add(q === 0 ? 'is-out' : 'is-busy');
    var span = it.querySelector('.lcs-q span'); if (span && q) span.textContent = q;
    var old = it.querySelector('.lcs-err'); if (old) old.remove();
    fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: key, quantity: q }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (c) { newIds = []; setTimeout(function () { render(c); syncCount(c); busy = false; }, q === 0 ? 240 : 0); })
      .catch(function (j) {
        busy = false;
        it.classList.remove('is-busy', 'is-out');
        if (span) span.textContent = it.getAttribute('data-q');
        var p = document.createElement('p'); p.className = 'lcs-err';
        p.textContent = (j && j.description) ? j.description : 'Chưa cập nhật được, bạn thử lại nhé.';
        it.appendChild(p);
      });
  }

  function open(opts) {
    build();
    opts = opts || {};
    okEl.innerHTML = opts.added ? '<div class="lcs-ok" role="status"><i>✓</i><span>Đã thêm vào giỏ' + (opts.title ? ': ' + esc(opts.title) : '') + '</span></div>' : '';
    var p = opts.cart ? Promise.resolve(opts.cart) : load();
    if (!cart) list.innerHTML = '<div class="lcs-empty"><p>Đang tải giỏ…</p></div>';
    p.then(function (c) { render(c); syncCount(c); }).catch(function () { list.innerHTML = '<div class="lcs-empty"><p>Chưa tải được giỏ. <a href="/cart">Mở trang giỏ hàng</a></p></div>'; });
    if (!root.classList.contains('on')) {
      lastFocus = document.activeElement;
      document.documentElement.classList.add('lcs-lock');
      requestAnimationFrame(function () { root.classList.add('on'); setTimeout(function () { try { sheet.focus({ preventScroll: true }); } catch (e) {} }, 60); });
    }
  }
  function close() {
    if (!root || !root.classList.contains('on')) return;
    root.classList.remove('on');
    document.documentElement.classList.remove('lcs-lock');
    newIds = [];
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
  }

  /* ---------- ảnh bay vào giỏ ---------- */
  function visible(el) {
    if (!el) return null;
    var r = el.getBoundingClientRect();
    if (!r.width || !r.height || r.bottom < 0 || r.top > innerHeight || r.right < 0 || r.left > innerWidth) return null;
    var cs = getComputedStyle(el); if (cs.visibility === 'hidden' || +cs.opacity === 0) return null;
    return r;
  }
  function target() {
    var cands = [document.querySelector('.lm-tab[data-p="cart"] svg'), document.querySelector('.header-area .minicart-btn'), document.querySelector('.minicart-btn')];
    for (var i = 0; i < cands.length; i++) { var r = visible(cands[i]); if (r) return { x: r.left + r.width / 2, y: r.top + r.height / 2, el: cands[i].closest('a,button') || cands[i] }; }
    return { x: innerWidth - 32, y: 32, el: null };
  }
  var lastTap = null;
  document.addEventListener('pointerdown', function (e) { lastTap = e.target; }, true);
  function originImg() {
    var t = lastTap;
    var card = t && t.closest && t.closest('.product-item, .pmx-card, .mxa-card');
    if (card) { var ci = card.querySelector('img'); if (visible(ci)) return ci; }
    var st = t && t.closest && t.closest('.lp-sticky');
    if (st) { var si = st.querySelector('img'); if (visible(si)) return si; }
    var best = null, area = 0;
    document.querySelectorAll('[data-lp-gal] img').forEach(function (im) {
      var r = visible(im); if (!r) return;
      var a = (Math.min(r.right, innerWidth) - Math.max(r.left, 0)) * (Math.min(r.bottom, innerHeight) - Math.max(r.top, 0));
      if (a > area) { area = a; best = im; }
    });
    if (best) return best;
    var s2 = document.querySelector('.lp-sticky img'); if (visible(s2)) return s2;
    return null;
  }
  function bump(el) { if (!el || RM || !el.animate) return; el.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.28)' }, { transform: 'scale(1)' }], { duration: 380, easing: EASE }); }
  function fly(src, from) {
    return new Promise(function (res) {
      var tg = target();
      if (RM || !Element.prototype.animate || !src) { bump(tg.el); res(); return; }
      var r = from || { left: innerWidth / 2 - 60, top: innerHeight / 2 - 60, width: 120, height: 120 };
      var size = Math.max(56, Math.min(160, r.width, r.height));
      var x0 = r.left + r.width / 2 - size / 2, y0 = r.top + r.height / 2 - size / 2;
      var d = document.createElement('img');
      d.className = 'lcs-fly'; d.src = src; d.alt = ''; d.setAttribute('aria-hidden', 'true');
      d.style.cssText = 'left:' + x0 + 'px;top:' + y0 + 'px;width:' + size + 'px;height:' + size + 'px';
      document.body.appendChild(d);
      var dx = tg.x - (x0 + size / 2), dy = tg.y - (y0 + size / 2), sc = 26 / size;
      var an = d.animate([
        { transform: 'translate(0,0) scale(1)', opacity: 1 },
        { transform: 'translate(' + dx * 0.3 + 'px,' + (dy * 0.3 - 90) + 'px) scale(' + (0.5 + sc / 2) + ')', opacity: 1, offset: 0.42 },
        { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(' + sc + ')', opacity: 0.2 }
      ], { duration: 680, easing: 'cubic-bezier(.45,.05,.35,1)', fill: 'forwards' });
      an.onfinish = function () { d.remove(); bump(tg.el); res(); };
      setTimeout(function () { if (d.parentNode) { d.remove(); res(); } }, 1200);
    });
  }

  /* Sau khi theme thêm xong (Shopify.addItemFromForm / addItem gọi cartPopapForm / cartPopap): bay + mở ngăn giỏ. */
  function afterAdd(id) {
    var im = originImg();
    var src = im ? (im.currentSrc || im.src) : '';
    var r = im ? im.getBoundingClientRect() : null;
    if (!src) { var any = document.querySelector('[data-lp-gal] img, .lp-sticky img'); if (any) src = any.currentSrc || any.src; }
    if (!r) { var from = (lastTap && lastTap.closest && lastTap.closest('button,a')) || document.getElementById('AddToCart'); if (visible(from)) r = from.getBoundingClientRect(); }
    var title = ((document.querySelector('.product-details-content .product-name') || {}).textContent || '').trim();
    var card = lastTap && lastTap.closest && lastTap.closest('.product-item');
    if (card) { var n = card.querySelector('.product-name'); if (n) title = n.textContent.trim(); }
    newIds = id ? [+id] : [];
    var cp = load();
    var fp = fly(src, r);
    var btn = document.getElementById('AddToCart');
    Promise.all([cp, fp]).then(function (v) {
      syncCount(v[0]);
      open({ added: true, title: title, cart: v[0] });
      if (btn) setTimeout(function () { btn.classList.remove('is-added'); }, 1800);
    }).catch(function () { open({ added: true, title: title }); });
  }
  function hook() {
    var S = window.Shopify;
    if (!S || !S.cartPopapForm || S.cartPopapForm.lcs) return !!(S && S.cartPopapForm && S.cartPopapForm.lcs);
    S.cartPopapForm = function (id) { afterAdd(id); }; S.cartPopapForm.lcs = 1;
    S.cartPopap = function (id) { afterAdd(id); }; S.cartPopap.lcs = 1;
    /* theme gốc eval() phản hồi lỗi (HTML khi máy chủ bận) rồi im lặng: báo lỗi dễ hiểu, trả nút về trạng thái thường */
    S.onError = function (xhr) {
      var m = '';
      try { var j = JSON.parse(xhr.responseText); m = j.description || j.message || ''; } catch (e) {}
      if (!m) m = xhr && xhr.status === 429 ? 'Đang có nhiều lượt đặt, bạn bấm lại sau vài giây nhé.' : 'Chưa thêm được vào giỏ, bạn thử lại nhé.';
      if (window.LamyCart && LamyCart.toast) LamyCart.toast(esc(m), true, false); else alert(m);
      var b = document.getElementById('AddToCart'); if (b) { b.classList.remove('is-adding', 'is-added', 'loading', 'adding'); b.disabled = false; }
    };
    return true;
  }
  if (!hook()) {
    var tries = 0, tm = setInterval(function () { if (hook() || ++tries > 40) clearInterval(tm); }, 150);
    document.addEventListener('DOMContentLoaded', hook);
  }

  /* Mở ngăn giỏ thay cho ngăn giỏ cũ / trang giỏ (trừ khi đang ở trang giỏ) */
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) return;
    var a = e.target.closest && e.target.closest('.minicart-btn, .lm-tab[data-p="cart"], .pmx-pill, .lc-toast a[href="/cart"], a.lp-cart-link');
    if (!a || onCartPage) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var t = document.querySelector('.lc-toast.on'); if (t) t.classList.remove('on');
    open();
  }, true);

  /* Thanh mua ghim (điện thoại): ẩn khi nút Thêm vào giỏ gốc đang trên màn hình, hiện khi nút gốc ra khỏi màn hình */
  var form = document.getElementById('AddToCartForm');
  var box = form && (form.querySelector('.quantity-cart-box') || form);
  if (box && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (en) {
      document.documentElement.classList.toggle('lm-atc-in', en[0].isIntersecting);
    }, { rootMargin: '0px 0px -130px 0px' }).observe(box);
  }

  window.LamySheet = { open: open, close: close, fly: fly };
})();
